import React,{Component} from 'react';
import {ref} from '../config/constants'
import {formatPrice,formatQuantity} from '../helpers/helpers'

class QBendedViewPrint extends Component{
    constructor(){
        super();
        this.state ={
            bended :{}
        }
            
    }
    
    componentWillMount(){
        let category = ref.child("BendedPrice").orderByChild('status').equalTo('Active');
            category.on("value", function(snap){
                this.setState({
                    bended : snap.val()
                })
            }.bind(this))

    }

    render() { 
           
           var thick = this.props.product.productThickness
                thick = thick.slice(-3)
               
        return (
                <tr >
                    <td className="pName">{this.props.product.productName}</td>
                    <td className="pDimension">
                    0.{thick}x{ 
                        Object.keys(this.state.bended).map(key=>{
                            if(key === this.props.product.productDimension){
                            var product =  this.state.bended[key] 
                            
                            return product.dimension  
                            }
                        })
                    }
                    </td>
                    <td className="pQtyPUnit">{formatQuantity(this.props.product.productNumber)}</td>                    
                    <td className="unitAlone">{this.props.product.productUnit}</td>

                    <td className="pPricePunit">{formatPrice(this.props.product.productPrice)}</td>                    
                    <td className="priceUnitAlone">/{this.props.product.productUnit}</td>

                    <td className="pDisc">{this.props.product.productDiscount}%</td>
                    <td className="pAmount">{formatPrice(this.props.product.productTotal)}</td>
                </tr>
                    
 
        );
    }
}

export default  QBendedViewPrint;


// WEBPACK FOOTER //
// ./src/components/QBendedViewPrint.js